import { formatPhoneNumber, normalizePhoneInput } from "@/util/formatters";
import { useTranslations } from "@frontend/lib/next-intl-typed";
import { cn } from "@frontend/shared/lib/utils";
import { formatDistance } from "../geocoding-utils";

interface LocationCardProps {
  primaryColor?: string;
  secondaryColor?: string;
  index: number;
  siteName: string;
  address: string;
  phoneNumber?: string;
  isSelected: boolean;
  onSelect: () => void;
  distance?: number;
}

export function LocationCard({
  primaryColor,
  secondaryColor,
  index,
  siteName,
  address,
  phoneNumber,
  isSelected,
  onSelect,
  distance,
}: LocationCardProps) {
  const t = useTranslations("Shop");
  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        "w-full flex flex-row items-start p-4 gap-2 lg:gap-4 hover:bg-gray-50 transition-colors",
        isSelected && "bg-gray-50",
        index !== 0 && "border-t border-t-[#E1E1E1]",
      )}
    >
      <div className="relative flex justify-center rounded-md">
        {/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M23.52 11.648C23.52 18.704 14 25.76 14 25.76C14 25.76 4.47998 18.704 4.47998 11.648C4.47998 9.15283 5.48298 6.75987 7.26832 4.99553C9.05367 3.23119 11.4751 2.23999 14 2.23999C16.5248 2.23999 18.9463 3.23119 20.7316 4.99553C22.517 6.75987 23.52 9.15283 23.52 11.648Z"
            fill={secondaryColor || "#01A0B5"}
          />
        </svg>
        <p className="absolute top-1 text-white text-center text-xs">
          {++index}
        </p>
      </div>
      <div className="flex flex-row items-start gap-4 w-full h-16">
        <div className="flex flex-col items-start w-full">
          <p
            className="font-medium lg:text-sm text-xs text-left"
            style={{ color: primaryColor || "#000000" }}
          >
            {siteName}
          </p>
          <p className="text-xs text-gray-500 text-left">{address}</p>
          {phoneNumber && (
            <p className="text-xs text-gray-500">
              {formatPhoneNumber(normalizePhoneInput(phoneNumber))}
            </p>
          )}
        </div>

        <div className="flex w-fit h-full flex-row lg:items-center items-end justify-end">
          <div className="flex flex-col items-end gap-2">
            {distance && (
              <p
                className="text-sm text-gray-500"
                style={{
                  color: secondaryColor || "#000000",
                }}
              >
                {formatDistance(distance)}
              </p>
            )}
            <div
              className={cn("w-[100px] py-2 rounded-full text-white ")}
              style={{
                backgroundColor: isSelected
                  ? primaryColor || "#000000"
                  : "#D9D9D9",
              }}
            >
              {isSelected ? (
                <p className="text-xs font-light">{t("Selected")}</p>
              ) : (
                <p className="text-xs font-light">{t("Select")}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </button>
  );
}
